import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import { Modal, ModalTitle, ModalBody, ModalFooter } from '@vds/modals';
import { Title, Micro } from '@vds/typography';
import { InHomeUtils } from '../../util/inhomeUtils';
import {
    Accordion,
    AccordionItem,
    AccordionHeader,
    AccordionDetail,
    AccordionTitle,
} from '@vds/accordions';
import {TitleLockup}  from '@vds/type-lockups';
import { Button } from '@vds/buttons';

class faq extends React.PureComponent {
    constructor(props) {
        super(props);
        this.currOpenHelpAccordion = '';
    }

    // handleKeyDown(e) {
    //     if (e.keyCode === 13 || e.keyCode === 32) {
    //         this.onAcordionClick(e);
    //     }
    // }

    // handleKeyDownSibling(e) {
    //     let prevSibling = e.target.previousElementSibling;
    //     if (e.keyCode === 13 || e.keyCode === 32) {
    //         prevSibling.focus();
    //         prevSibling.click();
    //     }
    // }

    // onAcordionClick = (e) => {
    //     let accordHeaderElement = (e.target.className.indexOf('m_accordion-summary') !== -1) && e.target;
    //     if (!accordHeaderElement) {
    //         accordHeaderElement = (e.target.parentElement.className.indexOf('m_accordion-summary') !== -1) && e.target.parentElement;
    //     }
    //     if (accordHeaderElement) {
    //         let nextElementSibling = e.target.nextElementSibling;
    //         if (accordHeaderElement.className.indexOf("open") < 0) {
    //             if (this.currOpenHelpAccordion && this.currOpenHelpAccordion.className.indexOf('open') !== -1) {
    //                 this.currOpenHelpAccordion.className = this.currOpenHelpAccordion.className.replace(" open", "");
    //                 this.currOpenHelpAccordion.setAttribute('aria-expanded', false);
    //                 let currentNextElementSibling = this.currOpenHelpAccordion.nextElementSibling;
    //                 if (currentNextElementSibling) {
    //                     currentNextElementSibling.setAttribute('tabIndex', '-1');
    //                 }
    //             }
    //             accordHeaderElement.className = accordHeaderElement.className.concat(" open");
    //             this.currOpenHelpAccordion = accordHeaderElement;
    //             accordHeaderElement.setAttribute('aria-expanded', true);
    //             if (nextElementSibling) {
    //                 nextElementSibling.setAttribute('tabIndex', '0');
    //             }
    //         }
    //         else {
    //             accordHeaderElement.className = accordHeaderElement.className.replace(" open", "");
    //             this.currOpenHelpAccordion = undefined;
    //             accordHeaderElement.setAttribute('aria-expanded', false);
    //             if (nextElementSibling) {
    //                 nextElementSibling.setAttribute('tabIndex', '-1');
    //             }
    //         }
    //     }
    // }

    render() {
        let faqContents = '';
        let faqFragments = '';
        let pathName = window.location.pathname;

        if ((this.props.pageName === "buildproduct" || this.props.pageName === "streamline"  || this.props.pageName === "streamlinetvvoice" || this.props.pageName?.toLowerCase() === "popularplans") && this.props.faqBuildProduct !== undefined) {
            faqFragments = this.props.faqBuildProduct;
        } else if (this.props.pageName === "checkout" && this.props.faqCheckout !== undefined) {
            faqFragments = this.props.faqCheckout;
        } else if (this.props.pageName === "nsinotification" && this.props.faqNsi !== undefined) {
            faqFragments = this.props.faqNsi;
        } else if (this.props.pageName === "movelanding" && this.props.faqMoveLanding !== undefined) {
            faqFragments = this.props.faqMoveLanding;
        }

        // if(pathName.indexOf('/inhome/moves/buildproducts') != -1 || pathName.indexOf('/inhome/moves/checkout') != -1 || pathName.indexOf('/inhome/moves/buildproductsRskn') != -1){
        //     faqFragments = this.props.faqMoveLanding;
        // }

        if (faqFragments !== null && faqFragments !== '' && faqFragments.length > 0) {
            faqContents = faqFragments.map((faqItem, index) => {
                return (
                    // <ul className="w_list-control w_faq-list margin-top-zero" data-list-control data-tips-accordion key={index}>
                    //     <li className="m_accordion-summary m_single" aria-expanded="false" role="tab" tabIndex="0" onKeyDown={(e) => this.handleKeyDown(e)} onClick={(e) => this.onAcordionClick(e)}>
                    //         <p className="bold">{faqItem.question}</p>
                    //     </li>

                    //     <li className="m_accordion-details bg-white-active padall" aria-hidden="false"
                    //         onKeyDown={(e) => this.handleKeyDownSibling(e)} role="tabpanel">
                    //         <p className="margin-bottom-zero">{ReactHtmlParser(faqItem.answer)}</p>
                    //     </li>
                    // </ul>

                    <Accordion>
                        <AccordionItem>
                            <AccordionHeader>
                                <AccordionTitle primitive="h3">{faqItem.question}</AccordionTitle>
                            </AccordionHeader>
                            <AccordionDetail>
                                <div style={{color:"#6F7171"}} >{ReactHtmlParser(faqItem.answer)}</div>
                            </AccordionDetail>
                        </AccordionItem>                    
                    </Accordion>
                )
            })
        }

        return (
            <div>
                 {!(this.props.buildProductState.isReskin && this.props.lqState.runtimeKey.EnableReskin === 'Y') && <ModalTitle>
                    Frequently Asked Questions
                 </ModalTitle>}
                 {(this.props.buildProductState.isReskin && this.props.lqState.runtimeKey.EnableReskin === 'Y') && <TitleLockup
                    data={{
                    eyebrow: {
                    size: 'titleMedium',
                    children: '',
                    },
                    title: {
                    bold: false,
                    size: 'titleLarge',
                    primitive:'h2',
                    children: 'Frequently Asked Questions',
                    },
                    }}
                    />}
                <ModalBody>
                    <div id="FAQModalContent" style={{minHeight:"80vh"}}>
                    
                        {faqContents}
                    </div>
                </ModalBody>
                <ModalFooter>
                    <div className="modalFooterButtonReskin2">
                        <Button size="large" id="btnClose" onClick={this.props.closeModel}>
                            Close
                        </Button>
                    </div>
                </ModalFooter>
            </div>
        )
    }
}
export default faq;
